import { REGISTER_URL, steps } from "../data/content";

export function HowItWorks(): JSX.Element {
  return (
    <section
      id="so-gehts"
      aria-labelledby="how-title"
      className="py-20 sm:py-24 lg:py-28"
    >
      <div className="container-welope">
        <div className="bloom-on-scroll mx-auto max-w-3xl text-center">
          <p className="section-eyebrow">So geht's</p>
          <h2
            id="how-title"
            className="mt-3 font-headline text-headline-xl text-primary sm:text-[44px]"
          >
            In drei entspannten Schritten online.
          </h2>
          <p className="mt-5 font-body text-body-lg text-on-surface-variant">
            Kein langes Tutorial, keine 12-Schritt-Listen-Erfahrung. Profil anlegen, vernetzen,
            loslegen — fertig.
          </p>
        </div>

        <ol className="relative mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {steps.map((step, idx) => (
            <li
              key={step.number}
              className="bloom-on-scroll card-bloom relative overflow-hidden p-md"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <span
                aria-hidden
                className="absolute -top-6 -right-2 select-none font-headline text-[120px] font-extrabold leading-none text-primary-fixed"
              >
                {step.number}
              </span>

              <div className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-tertiary-fixed/50">
                <step.Icon className="h-6 w-6 text-tertiary" strokeWidth={1.6} aria-hidden />
              </div>
              <h3 className="relative mt-5 font-headline text-headline-md text-on-surface">
                {step.title}
              </h3>
              <p className="relative mt-2 font-body text-body-md text-on-surface-variant">
                {step.description}
              </p>

              <span
                aria-hidden
                className="absolute bottom-5 left-md right-md h-[2px] rounded-full bg-gradient-to-r from-transparent via-primary-fixed to-transparent md:hidden"
              />
            </li>
          ))}
        </ol>

        <div className="bloom-on-scroll mt-12 flex justify-center">
          <a href={REGISTER_URL} className="btn-primary">
            Auf die Warteliste
          </a>
        </div>
      </div>
    </section>
  );
}
